import { amountToDisplayValue, Text } from '@billy/design-system'

interface RegisterPaymentAmountProps {
  amount: number
  currencyId: string
}

export const RegisterPaymentAmount = ({ amount, currencyId }: RegisterPaymentAmountProps) => {
  return (
    <Text variant="h4" alignment="right">
      {amountToDisplayValue(amount)}{' '}
      <Text as="span" weight="medium">
        {currencyId}
      </Text>
    </Text>
  )
}
